import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import { Banner, RemoteCarouselWithBasket, RootLayout } from 'common/components';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { MODEL_JSON_STORE_NAME, modifyBannerImages, selectRegionId } from 'modules/model-json';
import { PromoBlock } from 'remotes/promo-block';
import { convertProducts } from 'utils';
import { CurrentStories, UspCards } from './components';
import { PROMO_BANNER, PROMO_ELEMENT_BLOCK, PROMO_PATH } from './promo-constants';

const promoFirstBanners = css`
  && {
    margin-bottom: 24px;

    @media (--only-tablet) {
      margin-bottom: 16px;
    }

    @media (--only-mobile) {
      margin-bottom: 12px;
    }
  }
`;

const promoSecondCarousel = css`
  && {
    margin-bottom: 60px;

    @media (--to-desktop) {
      margin-bottom: 44px;
    }

    @media (--only-mobile) {
      margin-bottom: 40px;
    }
  }
`;

/**
 * Вью лендинга Промо
 */
export const Promo = () => {
  const { modelJson } = useStoreon(MODEL_JSON_STORE_NAME);
  const { banners, bannersSecond, bannersThird = {}, offers, stories } = modelJson.model;
  const currentStoriesBanner = modifyBannerImages(stories.banner);
  const regionId = selectRegionId(modelJson);

  const isBannersSecond = Object.keys(bannersSecond).some(key => bannersSecond[key].length !== 0);
  const isBannersThird = Object.keys(bannersThird).some(key => bannersThird[key].length !== 0);
  console.log('currentStoriesBanner: ', currentStoriesBanner);

  return (
    <RootLayout currentPage={PROMO_PATH}>
      <Layout>
        <UspCards
          className={cn({
            [promoFirstBanners]:
              (isBannersSecond && !offers[1]) || (isBannersSecond && offers[1]?.products.length === 0),
          })}
          {...banners}
        />
        <PromoBlock elementBlock={PROMO_ELEMENT_BLOCK} />

        {currentStoriesBanner?.length > 0 && (
          <CurrentStories banner={currentStoriesBanner} currentStoryTitle={stories.title} />
        )}

        <PromoBlock elementBlock={PROMO_ELEMENT_BLOCK} position={1} />
        {isBannersSecond && <UspCards {...bannersSecond} />}
      </Layout>
      {offers[1] && offers[1]?.products.length > 0 && (
        <RemoteCarouselWithBasket
          className={promoSecondCarousel}
          elementBlock={PROMO_ELEMENT_BLOCK}
          productIdList={convertProducts(offers[1].products)}
          remoteId="otherCarousel"
          seeMoreLink={offers[1].link}
          showSeeMore
          title={offers[1].title}
        />
      )}
      <Layout>
        {isBannersThird && <UspCards {...bannersThird} />}
        {regionId !== KAZAKHSTAN && <Banner {...PROMO_BANNER} />}
      </Layout>
      {offers[0]?.products && (
        <RemoteCarouselWithBasket
          elementBlock={PROMO_ELEMENT_BLOCK}
          productIdList={convertProducts(offers[0].products)}
          remoteId="bestsellersCarousel"
          seeMoreLink={offers[0].link}
          showSeeMore
          title={offers[0].title}
        />
      )}
    </RootLayout>
  );
};
